import React, { useEffect, useContext, useState } from 'react';
import Button from '@mui/material/Button';
import { TextInput, FileUploader } from '../../components';
import { useForm } from '../../hooks';
import { SnackbarContext, UserContext } from '../../contexts';
import Handler from '../../Handler';
import API from '../../api';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';

export const MethodologyEvidenceAddPage = (props) => {
  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [formData, formMeta, formChange, setFormData, setFormMeta, formReset] = useForm(
    {
      title: '',
    },
    {
      title: {
        key: 'title',
        label: '증빙서류명',
        fullWidth: true,
        required: true,
      },
    },
  );

  const requsetAdd = () => {
    let body = Handler.formToBody(formData, formMeta);

    if (body) {
      API.Evidence.PostEvidence(body).then(
        (res) => {
          let result = res.data;
          console.log('PostTerms post result', result);
          history.push('/methodology/evidence/list');
        },
        (err) => {
          updateSnackbar({
            type: 'error',
            open: true,
            message: err.data.message,
          });
        },
      );
    } else {
      updateSnackbar({
        type: 'error',
        open: true,
        message: '필수정보를 확인하세요',
      });
    }
  };

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>증빙서류 추가</h3>
        </header>
        <div className='button__box'>
          <Button variant='contained' onClick={requsetAdd}>
            저장
          </Button>
        </div>
      </section>
      <section className='form__container'>
        <header>
          <h3>기본 정보</h3>
        </header>
        <div className='flex'>
          <TextInput value={formData.title} onChange={formChange} meta={formMeta.title}></TextInput>
        </div>
      </section>
    </article>
  );
};
